import AppService from "@/services/AppService.js";
const namespaced = true;
const state = {
  list: {},
  error: "",
  code: "",
  inv_settings_details: {},
  template_list: {},
  default_template_list: {},
  message: {},
  page: "",
  configure_list: [],
  cf_name: '',
  custom_list: [],
  delete_message: '',
  status_message: '',
  custom_limit: '',
  used_count: '',
  max_count: '',
  status_code: '',
  status_type: ''

};

const mutations = {
  LIST_DATA(state, list) {
    state.list = list.invoice_Stg;
    state.error = "";
  },
  SET_CODE(state, data) {
    state.status_code = data.code;
    state.status_message = data.status;
    state.status_type = data.type;
  },
  LIST_MAIL_DATA(state, list) {
    state.list = list.mail_list;
    state.error = "";
  },
  DELETE_RESULT(state, delete_result) {
    state.delete = delete_result;
    state.delete_message = delete_result;
  },
  LIST_TEMPLATE(state, data) {
    state.template_list = data.list.template_list;
    state.default_template_list = data.default_list.template_list;
  },
  STATUS_CODE(state, code) {
    state.code = code
    state.error = ''
  },
  CANCEL_STATUS(state, data) {
    state.message = data
    state.error = ''
  },
  GET_MESSAGE(state, data) {
    state.message = data
  },
  STATUS_MESSAGE(state, data) {
    state.status_message = data
  },
  CUSTOM_LIST(state, data) {
    state.custom_list = data
  },
  MAX_COUNT(state, data) {
    state.max_count = data
  },
  USED_COUNT(state, data) {
    state.used_count = data
  },
  CUSTOM_LIMIT(state, data) {
    state.custom_limit = data
  },
  CONFIGURE_LIST(state, data) {
    state.configure_list = data
  },
  FIELD_NAME(state, data) {
    state.cf_name = data
  }

};
const actions = {
  fetchCustomConfigure({
    commit,
    rootState
  }, data) {

    return AppService.settings.getCustomConfigure(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {

          commit('STATUS_CODE', response.code) // getting all the list in the api call
          commit('CONFIGURE_LIST', response.data.permissions) // getting all the list in the api call
          commit('FIELD_NAME', response.data.label_name) // getting all the list in the api call

        }

      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500 // getting all the list in the api call
        }
      })
  },
  configureAccessUpdate({
    commit,
    rootState
  }, data) {

    return AppService.settings.configureAccessUpdate(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit('STATUS_CODE', response.status) // getting all the list in the api call
          commit('STATUS_MESSAGE', response.data.status) // getting all the list in the api call

        }
        return response;

      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500 // getting all the list in the api call
        }
      })
  },
  fetchCustomList({
    commit,
    rootState
  }, data) {

    return AppService.settings.getCustomList(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {

          commit('STATUS_CODE', response.code) // getting all the list in the api call
          commit('CUSTOM_LIST', response.data.field) // getting all the list in the api call
          commit('MAX_COUNT', response.data.max_count) // getting all the list in the api call
          commit('USED_COUNT', response.data.used_count) // getting all the list in the api call

        }

      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500 // getting all the list in the api call
        }
      })
  },
  fetchCustomLimit({
    commit,
    rootState
  }, data) {

    return AppService.settings.getCustomLimit(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {

          commit('STATUS_CODE', response.code) // getting all the list in the api call
          commit('CUSTOM_LIMIT', response.data.remaining_fields) // getting all the list in the api call

        }

      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500 // getting all the list in the api call
        }
      })
  },
  customfieldcreate({
    commit,
    rootState
  }, data) {
    return AppService.settings
      .customFieldCreate(JSON.stringify(data), rootState.session.token)
      .then(response => {

        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("STATUS_MESSAGE", response.data.status); // getting all the list in the api call
          commit("STATUS_CODE", response.status); // getting all the list in the api call
          
        }
        return response
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  customfieldupdate({
    commit,
    rootState
  }, {
    id,
    data
  }) {
    return AppService.settings
      .customFieldUpdate(id, JSON.stringify(data), rootState.session.token)
      .then(response => {

        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("STATUS_MESSAGE", response.data.status); // getting all the list in the api call
          commit("STATUS_CODE", response.status); // getting all the list in the api call
        }
        return response
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },


  fetchfilterList({
    commit,
    rootState
  }, data) {

    return AppService.settings.getFilter(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("SET_CODE", response.data);
          commit('STATUS_CODE', response.code) // getting all the list in the api call
          return response.data
        }

      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500 // getting all the list in the api call
        }
      })
  },
  invoice({
    commit,
    rootState
  }, data) {
    return AppService.settings
      .postInvoiceSettings(JSON.stringify(data), rootState.session.token)
      .then(response => {
        commit('STATUS_CODE', response.status)
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        }
        return response
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  fetchprintsettings({
    commit,
    rootState
  }, data) {
    return AppService.settings
      .getPrintSettings(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("LIST_TEMPLATE", response.data.data);
        }
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  filterdetails({
    rootState
  }, data) {
    return AppService.settings
      .getFilterDetailsSettings(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        }
        return response.data
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  updateprintsettings({
    commit,
    rootState
  }, {
    id,
    data
  }) {
    return AppService.settings
      .postPrintSettings(id, data, rootState.session.token)
      .then(response => {
        commit('STATUS_CODE', response.status)
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          if (
            response.data.data.stg_menu == "Invoice" &&
            id == rootState.permission.inv_settings_details.print.templateId
          ) {
            rootState.permission.print_settings_details["Invoice"] =
              response.data.data.list;
          }
          if (
            response.data.data.stg_menu == "Credit Note" &&
            id == rootState.permission.crdt_settings_details.print.templateId
          ) {
            rootState.permission.print_settings_details["Credit Note"] =
              response.data.data.list;
          }
          if (
            response.data.data.stg_menu == "Sales" &&
            id == rootState.permission.quot_settings_details.print.templateId
          ) {
            rootState.permission.print_settings_details["Sales"] =
              response.data.data.list;
          }
          if (
            response.data.data.stg_menu == "Customer Statement" &&
            id == rootState.permission.cus_settings_details.print.templateId
          ) {
            rootState.permission.print_settings_details["Customer Statement"] =
              response.data.data.list;
          }
          if (
            response.data.data.stg_menu == "Payments Received" &&
            id == rootState.permission.pymnt_settings_details.print.templateId
          ) {
            rootState.permission.print_settings_details["Payments Received"] =
              response.data.data.list;
          }
          if (
            response.data.data.stg_menu == "Customer Advance" &&
            id == rootState.permission.cus_adv_settings_details.print.templateId
          ) {
            rootState.permission.print_settings_details["Customer Advance"] =
              response.data.data.list;
          }
          if (
            response.data.data.stg_menu == "Customer Deposit" &&
            id == rootState.permission.retainer_settings_details.print.templateId
          ) {
            rootState.permission.print_settings_details["Customer Deposit"] =
              response.data.data.list;
          }

        }
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  activeInvoiceTemp({
    commit,
    rootState
  }, data) {
    return AppService.settings
      .activeInvoiceTemp(data, rootState.session.token)
      .then(response => {
        commit('STATUS_CODE', response.status)
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          rootState.permission.print_settings_details[data.stg_menu] =
            response.data.data.list;
          //  to change Invoice settings
          rootState.permission[data.stg_print].print.templateId =
            data.id;
          state.list[data.stg_menu].print.templateId = data.id;

        }
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  general({
    commit,
    rootState
  }, data) {
    return AppService.settings
      .postGeneralSettings(JSON.stringify(data), rootState.session.token)
      .then(response => {
        rootState.permission.general_settings_details = response.data.data
        commit('STATUS_CODE', response.status)
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        }
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  fetchmaildetails({
    commit,
    rootState
  }, data) {
    return AppService.settings
      .getMailDetailsSettings(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("LIST_DATA", response.data.data);
        }
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  deletemailtemplate({
    commit,
    rootState
  }, data) {
    return AppService.settings
      .MailtemplateDelete(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit('STATUS_CODE', response.status)
        }
        return response
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  importopeningbalances({
    commit,
    rootState
  }, data) {
    return AppService.settings.getOpeningBalanceimport(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit('STATUS_CODE', response.status) // getting all the list in the api call
        }
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500 // getting all the list in the api call
        }
      })
  },
  importopeningbalancesvalidation({
    commit,
    rootState
  }, data) {
    return AppService.settings.getOpeningBalanceValidationstatus(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit('LIST_DATA', response.data) // getting all the list in the api call
        }
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500 // getting all the list in the api call
        }
      })
  },
  fetchopeningbalancetypedetails({
    commit,
    rootState
  }, {
    type,
    page,
    show
  }) {

    return AppService.settings.getOpeningBalanceType(type, page, show, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit('LIST_DATA', response.data) // getting all the list in the api call
        }
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500 // getting all the list in the api call
        }
      })
  },
  fetchopeningbalancedetails({
    commit,
    rootState
  }) {

    return AppService.settings.getOpeningBalance(rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit('LIST_DATA', response.data) // getting all the list in the api call
        }
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500 // getting all the list in the api call
        }
      })
  },
  createmailtemplate({
    commit,
    rootState
  }, data) {
    return AppService.settings
      .MailtemplateCreate(data, rootState.session.token)
      .then(response => {
        commit('STATUS_CODE', response.status)
        commit('GET_MESSAGE', response.data.status)
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else if (response.status == 201) {
          commit('CANCEL_STATUS', response.data.data)
        }
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  updatemailtemplate({
    commit,
    rootState
  }, {
    id,
    field
  }) {
    return AppService.settings
      .MailtemplateUpdate(id, field, rootState.session.token)
      .then(response => {
        commit('STATUS_CODE', response.status)
        commit('GET_MESSAGE', response.data.status)
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else if (response.status == 201) {
          commit('CANCEL_STATUS', response.data.data)
        }
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  viewmailtemplate({
    commit,
    rootState
  }, id) {
    return AppService.settings
      .MailtemplateView(id, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("LIST_MAIL_DATA", response.data);
        }
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  fetchinvoicesettings({
    commit,
    rootState
  }, data) {
    return AppService.settings
      .getInvoiceSettings(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          rootState.permission[data.stg_name] = response.data.invoice_Stg[data.stg_menu];
          commit("LIST_DATA", response.data);
        }
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  },
  postdelete({
    commit,
    rootState
  }, data) {
    return AppService.settings
      .postdelete(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("DELETE_RESULT", response.data.status); // getting all the list in the api call
          commit("STATUS_CODE", response.status); // getting all the list in the api call
        }
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500; // getting all the list in the api call
        }
      });
  }
};
export default {
  namespaced,
  state,
  mutations,
  actions
};